import React, { useState } from 'react'
import MainLayout from '../Layouts/MainLayout'
import VideoKeywordDetail from './VideoKeywordDetail'




function VideoKeywordContainer() {
  return (
    <MainLayout navTitle={"Video Keyword Details"} navSubTitle={"Welcome to ImagesBazaar"}>
      <VideoKeywordDetail/>
    </MainLayout>
  )
}

export default VideoKeywordContainer